<mat-form-field class="full-width">
  <mat-label>{{ field.label }}</mat-label>
  <mat-select #select multiple [(ngModel)]="ngModelValue">
    <mat-option
      (click)="optionClick()"
      *ngFor="let option of options; let i = index; trackBy: trackByMethod"
      [ngClass]="'test-booking-' + field.key.toLowerCase() + '-' + i"
      [value]="option.key"
    >
      {{ option.value }}
    </mat-option>
  </mat-select>
</mat-form-field>
<mat-error
  *ngIf="
    form.controls[field.key].touched &&
    form.controls[field.key].hasError('required')
  "
>
  {{ field.label }} <strong>måste anges</strong>
</mat-error>
